// /src/pages/OrderNovoPage.jsx - V11.3 (SINCRO DE TEMA SUPREMO)
import React, { useState, useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import UniversalOrderCard from '../components/cards/UniversalOrderCard'; 
import { OrderExecutionEngine } from '../api/OrderExecutionEngine';
import { UserExecutionEngine } from '../api/UserExecutionEngine';
import { FiRefreshCw, FiCpu, FiChevronDown } from 'react-icons/fi';
import { toast } from 'react-hot-toast';

export default function OrderNovoPage() {
    const [orders, setOrders] = useState([]);
    const [brokers, setBrokers] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadOrders = async () => {
        setLoading(true);
        try {
            const [boardRes, brokersData] = await Promise.all([
                OrderExecutionEngine.obterQuadroOperacoes(),
                UserExecutionEngine.listarContingente()
            ]);

            let triagemOrders = [];
            if (boardRes.success) {
                const pendingList = boardRes.data.PENDENTE || [];
                const godView = boardRes.data.GOD_VIEW || [];
                
                // Função que define se o pedido está VIVO na esteira (ou concluído/cancelado)
                const isAliveInPipeline = (o) => {
                    if (o.status === 'CONCLUIDO' || o.status === 'CANCELADO') return true;
                    if (o.subCategoriaInterna === 'CLIENTE_DEVE_AGIR' || o.status === 'AGUARDANDO_DOCS' || o.status === 'REANALISE PERMITIDA') return true;
                    if (o.subCategoriaInterna === 'CONSULTOR_DEVE_AGIR') return true;
                    if (o.subCategoriaInterna === 'UNITY_DEVE_AGIR' || o.status?.includes('QUALIDADE')) return true;
                    if (o.subCategoriaInterna === 'TIM_DEVE_AGIR') return true;
                    if (o.subCategoriaInterna === 'LOGISTICA_ENTREGA') return true;
                    // ATRIBUIDO vai pra consultor. Mas AGUARDANDO_TRIAGEM é justamente Triagem!
                    if (o.status === 'ATRIBUIDO') return true;
                    return false;
                };

                // O limbo é qualquer pedido que NÃO esteja vivo na esteira
                const limboList = godView.filter(o => !isAliveInPipeline(o) && o.status !== 'PENDENTE');
                
                // Triagem reúne a lista oficial de pendentes + qualquer perdido no limbo
                triagemOrders = [...pendingList, ...limboList];
            }

            setOrders(triagemOrders);
            setBrokers(Array.isArray(brokersData) ? brokersData.filter(b => 
                ['USER', 'ADM', 'GESTOR', 'MASTER'].includes(b.role?.toUpperCase())
            ) : []);
        } catch (err) {
            toast.error("Erro no downlink de ordens.");
            setOrders([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadOrders(); }, []);

    const handleAssign = async (orderId, brokerId) => {
        if (!brokerId) return;
        const success = await OrderExecutionEngine.atribuirPedido(orderId, brokerId);
        if (success) {
            // Força o pedido a renascer na esteira (coluna Triagem/Novos)
            await OrderExecutionEngine.atualizarStatus(
                orderId,
                'ATRIBUIDO',
                'Atribuído via Triagem. Pedido Renasceu!',
                'VENDA_ATIVA', // Categoria Base Padrão
                'AGUARDANDO_TRIAGEM', // Sub-categoria que faz ele cair na col-pendentes
                null
            );

            toast.success("ORDEM ENVIADA AO CONSULTOR");
            loadOrders();
        } else {
            toast.error("FALHA NA ATRIBUIÇÃO");
        }
    };

    return (
        <MainLayout>
            {/* 🎨 O container principal agora usa a cor de fundo do tema */}
            <div className="min-h-screen w-full p-8 md:p-16 space-y-16 transition-colors duration-500"
                 style={{ backgroundColor: 'var(--bg-main)', color: 'var(--text-primary)' }}>
                
                <header className="flex justify-between items-center border-b pb-12"
                        style={{ borderColor: 'var(--border-color)' }}>
                    <div>
                        <h1 className="text-6xl font-black uppercase italic tracking-tighter">
                            Triagem <span className="text-accent text-7xl">TIM</span>
                        </h1>
                        <p className="text-[10px] uppercase tracking-[0.4em] opacity-40 mt-2">
                            Triagem de Novos Contratos e Resgate do Limbo
                        </p>
                    </div>
                    
                    {/* Botão Dinâmico que segue o Tema */}
                    <button 
                        onClick={loadOrders} 
                        className="p-5 border rounded-3xl shadow-xl transition-all hover:scale-105 active:scale-95"
                        style={{ 
                            backgroundColor: 'var(--bg-card)', 
                            borderColor: 'var(--border-color)',
                            color: 'var(--accent-color)'
                        }}
                    >
                        <FiRefreshCw size={24} className={loading ? 'animate-spin' : ''} />
                    </button>
                </header>

                {loading ? (
                    <div className="py-40 text-center flex flex-col items-center opacity-40">
                        <FiCpu size={80} className="animate-spin mb-6 text-accent"/>
                        <span className="font-black uppercase tracking-widest">Varrendo Hangar...</span>
                    </div>
                ) : orders.length === 0 ? (
                    <div className="py-40 flex flex-col items-center justify-center text-center opacity-30">
                        <span className="font-black text-2xl md:text-4xl uppercase tracking-[0.2em] text-[var(--text-primary)]">Logo teremos mais pedidos...</span>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
                        {orders.map(order => (
                            <UniversalOrderCard 
                                key={order._id} 
                                order={order}
                                actions={
                                    <div className="relative">
                                        {/* 🛡️ O SELECT E OPTION agora herdam as regras do seu CSS base */}
                                        <select 
                                            onChange={(e) => handleAssign(order._id, e.target.value)}
                                            className="w-full h-16 px-8 rounded-2xl font-black uppercase appearance-none cursor-pointer focus:border-accent transition-all outline-none"
                                            style={{ 
                                                backgroundColor: 'var(--bg-card)', 
                                                color: 'var(--text-primary)',
                                                border: '1px solid var(--border-color)'
                                            }}
                                        >
                                            <option value="">Aguardando Designação...</option>
                                            {brokers.map(b => (
                                                <option key={b._id} value={b._id}>
                                                    🎖️ {b.name} {order.brokerId === b._id ? '(ATUAL)' : ''}
                                                </option>
                                            ))}
                                        </select>
                                        <FiChevronDown className="absolute right-6 top-1/2 -translate-y-1/2 text-accent pointer-events-none" />
                                    </div>
                                }
                            />
                        ))}
                    </div>
                )}
            </div>
        </MainLayout>
    );
}